import Alessandro from "../../../immagini/Alessandro.png";
import Cinzia from "../../../immagini/Cinzia.png";
import Cristian from "../../../immagini/Cristian.png";
import Matteo from "../../../immagini/Matteo.png";
import Mattia from "../../../immagini/Mattia.png";
import Gruppo1 from "../../../immagini/Gruppo1.png";
import Gruppo2 from "../../../immagini/Gruppo2.JPG";

export const TEAM_MEMBERS = [
  {
    name: "CRISTIAN",
    surname: "LANDINI",
    title: "Geometra",
    linkedin: "#", // Sostituire con il link reale
    email: "cristian.aurora@email.it", // Sostituire con l'email reale
    delay: 0,
    row: 1,
    image: Cristian,
  },
  {
    name: "ALESSANDRO",
    surname: "MADUZZI",
    title: "Geometra",
    linkedin: "#",
    email: "alessandro.aurora@email.it",
    delay: 100,
    row: 1,
    image: Alessandro,
  },

  {
    name: "MATTEO",
    surname: "FONTANA",
    title: "Architetto",
    linkedin: null,
    email: null,
    delay: 300,
    row: 2,
    image: Matteo,
  },
  {
    name: "CINZIA",
    surname: "CALANCA",
    title: "Architetto",
    linkedin: null,
    email: null,
    delay: 400,
    row: 2,
    image: Cinzia,
  },
  {
    name: "MATTIA",
    surname: "COFFANI",
    title: "Geometra",
    linkedin: null,
    email: null,
    delay: 200,
    row: 2,
    image: Mattia,
  },
];
